var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('contacts',{attrs:{"record":_vm.project,"editable":_vm.can_edit_prospective_data,"wizard-shown":_vm.wizardShown}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }